((Drupal, Splide) => {
  Drupal.behaviors.gliHeroBannerSlideshow = {
    attach(context) {
      if (context.getElementsByClassName('splide').length) {
        const splide = new Splide('.splide', {
          type: 'fade',
          rewind: true,
          speed: 1000,
          drag: false,
          autoplay: true,
          interval: 7500,
          pauseOnHover: false,
          pauseOnFocus: false,
          updateOnMove: true
        }).mount();

        const button = context.querySelector('.splide__play-pause');
        if (button) {
          const pausedClass = 'is-paused';
          const flag = 99;
          const Autoplay = splide.Components.Autoplay;

          splide.on('autoplay:play', function() {
            button.classList.remove(pausedClass);
            button.querySelector('span').textContent = 'Pause';
          });

          // Add the paused class and change the label to "Play".
          splide.on('autoplay:pause', function() {
            button.classList.add(pausedClass);
            button.querySelector('span').textContent = 'Play';
          });

          // Toggle play/pause when the button is clicked.
          button.addEventListener('click', function(e) {
            if (button.classList.contains(pausedClass) ) {
              Autoplay.play(flag);
            } else {
              Autoplay.pause(flag);
            }
          }, button);
        }
      }
    },
  };
})(Drupal, Splide);
